document.querySelectorAll('.content-page .accordion details').forEach((details) => {
  const summary = details.querySelector('summary');
  const content = details.querySelector('.accordion__content');
  
  if (!summary || !content) return;
  
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', details.hasAttribute('open'));
  
  if (content.id) {
    summary.setAttribute('aria-controls', content.id);
  }
  
  summary.addEventListener('click', (event) => {
    event.preventDefault();
    const isOpen = details.hasAttribute('open');
    
    if (isOpen) {
      closeAccordion(details, content);
    } else {
      openAccordion(details, content);
    }
  });
  
  details.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      closeAccordion(details, content);
    }
  });
});

function openAccordion(details, content) {
  // Instantly show the content
  content.style.display = 'block';
  content.style.maxHeight = 'none';
  content.style.opacity = '1';
  content.style.transition = 'none'; // Disable any transition

  details.setAttribute('open', '');
  const summary = details.querySelector('summary');
  if (summary) {
    summary.setAttribute('aria-expanded', 'true');
  }
}

function closeAccordion(details, content) {
  // Instantly hide the content
  content.style.transition = 'none'; // Disable any transition
  content.style.maxHeight = '0';
  content.style.opacity = '0';
  content.style.display = 'none';

  details.removeAttribute('open');
  const summary = details.querySelector('summary');
  if (summary) {
    summary.setAttribute('aria-expanded', 'false');
  }
}

